<!--
作者：小明哥
组件：视频列表
框架：VUE、vue-router、vuex、axios、ElementUI等
脚手架：VUE CLI3
-->
<template>
    <div class="develop-video-content">
        <div v-if="fromPage<0" class="public-content-header">
            <div class="public-content-header-right flex">
                <p class="header-class">共<span class="orange">{{total}}</span>个课程</p>
                <slot></slot>
                <p class="gray-9"><a :href="moreUrl">查看更多课程>></a></p>
            </div>
        </div>
        <div class="video-list" :style="{width}">
            <div :class="className" v-for="(item,index) in list"  :key='index'>
                <div class="item-img" @click="toCourseDetail(item.courseId)">
                    <img v-if="item.courseImg" :src="item.courseImg | imgUrl" alt="">
                    <!--<img v-else src="../assets/img/defaultimg.jpg" alt="">-->
                    <div class="item-img-modal">
                        <img style="border-radius: 5px;" src="../assets/img/develop/develop-play.png"
                             :alt="item.courseTypeName +'-'+item.courseName">
                    </div>
                    <p class="video-time">{{item.createTime | dateFormat}}</p>
                </div>
                <p class="item-name" style="color: #909399;font-size: 15px">{{item.courseTypeName}} [{{item.courseCategoryName | courseCategoryNameDes}} ]</p>
                <p class="item-name">{{item.courseName}}</p>
                <p class="item-study">
                    <!--<span v-if="item.price>0" class="item-price"><s>￥{{item.price}}</s></span>-->
                    <span class="item-free">免费</span>
                    <span v-if="item.studyNumber==0"></span>
                    <span v-else>{{item.studyNumber | number}}人学</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "VideoListComm",
        props:{
            //完整的URL
            fullUrl:{
                type:String,
                default:null
            },
            //参数
            params:{
                type:String,
                default:null
            },
            //调用页面
            fromPage:{
                type:Number,
                default:-1
            },
            //是否初始化数据，在列表调用时，可以设置为false，不主动初始化数据，通过监听执行
            isLoadData:{
                type:Boolean,
                default:true
            },
            //加载完毕，让父组件的loadSuccess方法处理结果集
            loadSuccess:{
                type:Function,
                default:null
            }
        },
        data(){
            return {

                list: [],
                total:0,
                url: null,
                //TODO
                //带优化，需要设置参数，进入课程页面后，自动搜索到此类课程。
                moreUrl : "course",
                className:["list-item"],
                width:'1200px'
            }
        },
        created: function () {
            //是否初始化数据
            if(this.isLoadData){
                this.init();
            }
            if (this.fromPage==2) {
                this.className = ["list-item","home-list-item"]
                this.width = "920px"
            }
            if(this.fromPage == 3){
                this.width = "280px"
            }
        },
        methods: {
            init() {
               this.getData();
            },

            //获取页面数据,支持直接传参数
            getData(params) {
                console.log("获取页面数据 URL===>",params)
                if(params){
                    this.url = "/web/course" + params;
                }else{
                    if(this.params == undefined) {
                        this.url = "/web/course?size = 8";
                    }else {
                        this.url = "/web/course" + this.params;
                    }
                }
                //如果是完整的url
                if(this.fullUrl) {
                    this.url = this.fullUrl;
                }
                console.log("第5步： video-list-comm组件内，请求API的URL======>>>>",this.url);
                this.$axios.get(this.url).then(rs => {
                    // rs = rs.data;
                    if (rs.code == 0) {
                        this.list  = rs.data.records;
                        this.total = rs.data.total;
                        //返回结果集给父组件
                        if(this.loadSuccess) {
                            this.loadSuccess(rs.data);
                        }
                    } else {
                        this.$message.error("错误："+rs.msg);
                    }
                }).catch(e => {
                    this.$message.error("错误："+e);
                });
            },

            //详情页跳转
            toCourseDetail: function (vid) {
                window.open("/courseDetail/" + vid+"/0");
            }
        }
    }
</script>

<style scoped>

</style>
